import { BaseSchemaExtension, serializeToHTML } from "@smartsuite/smartdoc";
import type { EditorData } from "@smartsuite/types";

const helpDocExtensions = [
  new BaseSchemaExtension({
    enableParagraphAlignment: false,
  }),
];

export function captionToEditorData(caption?: string): EditorData {
  const doc = {
    type: "doc" as const,
    content: caption
      ? [
          {
            type: "paragraph" as const,
            attrs: { textAlign: null },
            content: [{ type: "text" as const, text: caption }],
          },
        ]
      : [],
  };
  return {
    data: doc,
    html: serializeToHTML(doc, helpDocExtensions),
  };
}
